// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class IAuthenticationData {
    'token'?: string;
    'sessionId'?: number;
    'createDate'?: Moment;
    'expirationDate'?: Moment;
    'roles'?: Array<string>;
    'features'?: Array<string>;
    'username'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof IAuthenticationData>> = [
        {
            "name":     "token",
            "baseName": "token",
            "type":     "string"
        },
        {
            "name":     "sessionId",
            "baseName": "sessionId",
            "type":     "number"
        },
        {
            "name":     "createDate",
            "baseName": "createDate",
            "type":     "Date"
        },
        {
            "name":     "expirationDate",
            "baseName": "expirationDate",
            "type":     "Date"
        },
        {
            "name":     "roles",
            "baseName": "roles",
            "type":     "Array<string>"
        },
        {
            "name":     "features",
            "baseName": "features",
            "type":     "Array<string>"
        },
        {
            "name":     "username",
            "baseName": "username",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return IAuthenticationData.attributeTypeMap;
    }
}
